import { render, staticRenderFns } from "./uploaded.vue?vue&type=template&id=32bd5187&scoped=true"
import script from "./uploaded.vue?vue&type=script&lang=js"
export * from "./uploaded.vue?vue&type=script&lang=js"
import style0 from "./uploaded.vue?vue&type=style&index=0&id=32bd5187&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bd5187",
  null
  
)

export default component.exports